import React from "react";

import AppState from "./model/AppState";
import LojaModel from "./model/LojaModel";
import ListaModel from "./model/ListaModel";
import QueryString from "query-string";
import ListaItemModel from "./model/ListaItemModel";
import ListaItem from "./components/ListaItem";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import Rodape from "./components/Rodape";
import NavegadorUtil from "./util/NavegadorUtil";
import Carregando from "./components/Carregando";
import { RouteComponentProps, Link, withRouter } from "react-router-dom";

interface IListaDetalheProps extends RouteComponentProps {}

type ListaDetalheState = {
  lista?: ListaModel;
  carregando: boolean;
  concluido: boolean;
};

class ListaDetalhe extends React.Component<
  IListaDetalheProps,
  ListaDetalheState
> {
  constructor(prop: IListaDetalheProps) {
    super(prop);

    this.adicionarTudo = this.adicionarTudo.bind(this);

    this.state = {
      lista: undefined,
      carregando: false,
      concluido: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Lista detalhe");
    let query: any = QueryString.parse(this.props.location.search);
    this.setState({ carregando: true });
    AppState.getLista(query.listaId).then((lista: ListaModel) => {
      this.setState({
        lista,
        carregando: false,
        concluido: true,
      });
    });
  }

  async adicionarTudo(listaId: string): Promise<void> {
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    if (loja && !loja.retirada) {
      NavegadorUtil.alerta(
        this,
        "Esta loja não aceita pedidos pelo app.  Favor selecionar outra loja ou dirigir-se até a loja física."
      );
    } else {
      const lista: ListaModel = await AppState.getLista(listaId);
      const proms: any = [];

      this.setState({ carregando: true });

      try {
        for (const item of lista.items) {
          let qtdItem: number = item.quantidade;
          while (qtdItem > 0) {
            proms.push(await AppState.addCarrinhoItem(item.produto, item.notas).catch((ex) => {
              throw ex.replace('produto selecionado', `produto selecionado [${item.produto.nome}]`);
            }));
            qtdItem--;
          }
        }
      } catch(ex) {
        NavegadorUtil.alerta(this, ex.replace("\\n", " "));
        this.setState({ carregando: false });
        return;
      }

      Promise.all(proms)
        .then(() => {
          NavegadorUtil.alerta(
            this,
            "Itens adicionados ao carrinho com sucesso."
          );
          this.setState({ carregando: false });
        })
        .catch(() => {
          NavegadorUtil.alerta(
            this,
            "Alguns itens não foram adicionados por não estarem em estoque.  Favor revisar o carrinho."
          );
          this.setState({ carregando: false });
        });
    }
  }

  render(): any {
    const { lista, carregando, concluido } = this.state;
    const lojaSelecionada: LojaModel | null = AppState.getLojaSelecionada();
    const retUrl: string = window.location.hash.substr(1);

    if (!lista) {
      return (
        <section className="lists">
          <Carregando exibir={carregando} concluido={concluido}></Carregando>
        </section>
      );
    }

    if (lojaSelecionada && lista) {
      return (
        <section className="lists">
          <div className="header">
            <BotaoVoltar titulo={lista.nome}></BotaoVoltar>
          </div>
          <div className="store">
            <p>
              Preços da <span>{lojaSelecionada.nome}</span>
            </p>
            <Link to={NavegadorUtil.getUrl(`/lojas?returnUrl=${retUrl}`)}>
              Alterar
            </Link>
          </div>
          {lista.items.length > 0 && (
            <div className="store">
              <p></p>
              <button>
                <img
                  src={NavegadorUtil.getUrl(
                    "/assets/images/icons/compartilhar-green.svg"
                  )}
                  alt="Compartilhar"
                  title="Compartilhar"
                />
                <div>Compartilhar</div>
              </button>
            </div>
          )}
          <ul className="items">
            {lista.items.map((item: ListaItemModel) => (
              <ListaItem
                item={item}
                listaId={lista.listaId}
                key={item.listaItemId}
                parent={this}
              ></ListaItem>
            ))}
          </ul>
          {lista.items.length === 0 && (
            <div className="empty-cart">
              <p>Nenhum item nesta lista</p>
              <p>
                <Link to={NavegadorUtil.getUrl("/home")}>Ir às compras</Link>
              </p>
            </div>
          )}
          {lista.items.length > 0 && (
            <button
              className="main-button"
              onClick={() => this.adicionarTudo(lista.listaId)}
            >
              Adicionar tudo ao carrinho
            </button>
          )}
          <Rodape parent={this} ativo="Lista"></Rodape>
          <Carregando exibir={carregando} concluido={concluido}></Carregando>
        </section>
      );
    }
  }
}

export default withRouter(ListaDetalhe);
